/**
 * Pakket samenstellen — Website/Webshop tabs, basispakket (radio), add-ons, totalen
 */
(function () {
  'use strict';

  function formatMoney(value) {
    var n = Number(value);
    if (Number.isNaN(n)) n = 0;
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: n % 1 === 0 ? 0 : 2,
    }).format(n);
  }

  function parsePrice(attr) {
    if (attr == null || attr === '') return 0;
    var s = String(attr).trim().replace(/\s/g, '').replace(',', '.');
    var n = parseFloat(s);
    return Number.isNaN(n) ? 0 : n;
  }

  function getActiveTab(root) {
    var v = (root.getAttribute('data-active-tab') || 'website').toString().toLowerCase().trim();
    if (v !== 'webshop' && v !== 'website') v = 'website';
    return v;
  }

  function setAddonVisibility(root, tab) {
    root.querySelectorAll('[data-addon-target]').forEach(function (row) {
      var tgt = row.getAttribute('data-addon-target');
      var show = tgt === 'both' || tgt === tab;
      if (show) {
        row.removeAttribute('hidden');
      } else {
        row.setAttribute('hidden', 'hidden');
      }
    });
  }

  function setPanelVisibility(root, tab) {
    root.querySelectorAll('[data-pkg-panel]').forEach(function (panel) {
      var p = panel.getAttribute('data-pkg-panel');
      if (p === tab) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });
  }

  function updateTabs(root, tab) {
    root.querySelectorAll('[data-pkg-tab]').forEach(function (btn) {
      var t = btn.getAttribute('data-pkg-tab');
      var active = t === tab;
      if (active) {
        btn.classList.add('package-builder__tab--active', 'shadow-sm');
        btn.classList.remove('text-muted-foreground', 'hover:text-foreground');
      } else {
        btn.classList.remove('package-builder__tab--active', 'shadow-sm');
        btn.classList.add('text-muted-foreground', 'hover:text-foreground');
      }
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
  }

  function setActiveTab(root, tab) {
    root.setAttribute('data-active-tab', tab);
    updateTabs(root, tab);
    setPanelVisibility(root, tab);
    setAddonVisibility(root, tab);
    recalc(root);
  }

  function recalc(root) {
    if (!root) return;
    var tab = getActiveTab(root);
    var outMonthly = root.querySelector('[data-pkg-total-monthly]');
    var outOnce = root.querySelector('[data-pkg-total-once]');
    var ctxLabel = root.querySelector('[data-pkg-context-label]');
    var monthly = 0;
    var once = 0;
    var items = [];

    var panel = root.querySelector('[data-pkg-panel="' + tab + '"]');
    var base = panel ? panel.querySelector('input[data-pkg-base]:checked') : null;

    if (base) {
      var bAmt = parsePrice(base.getAttribute('data-price'));
      var bType = base.getAttribute('data-price-type');
      var bLabel = base.getAttribute('data-label') || 'Basispakket';
      if (bType === 'monthly') {
        monthly += bAmt;
        items.push({ name: 'Basis: ' + bLabel, price: formatMoney(bAmt) + '/maand' });
      } else {
        once += bAmt;
        items.push({ name: 'Basis: ' + bLabel, price: formatMoney(bAmt) + ' (eenmalig)' });
      }
    }

    root.querySelectorAll('input[data-pkg-addon]').forEach(function (inp) {
      if (!inp.checked) return;
      var row = inp.closest('[data-addon-target]');
      if (!row || row.hasAttribute('hidden')) return;
      var label = inp.getAttribute('data-label') || '';
      var type = inp.getAttribute('data-price-type');
      var amt = parsePrice(inp.getAttribute('data-price'));
      if (type === 'monthly') {
        monthly += amt;
        items.push({ name: label, price: formatMoney(amt) + '/maand' });
      } else {
        once += amt;
        items.push({ name: label, price: formatMoney(amt) + ' (eenmalig)' });
      }
    });

    if (outMonthly) outMonthly.textContent = formatMoney(monthly);
    if (outOnce) outOnce.textContent = formatMoney(once);

    if (ctxLabel) {
      var lw = root.getAttribute('data-ctx-website') || 'Website';
      var ls = root.getAttribute('data-ctx-webshop') || 'Webshop';
      ctxLabel.textContent = 'Type: ' + (tab === 'webshop' ? ls : lw);
    }

    root.dataset.pkgPayload = JSON.stringify({
      context: tab,
      baseLabel: base ? base.getAttribute('data-label') : '',
      items: items,
      monthlyTotal: monthly,
      onceTotal: once,
    });
  }

  function handleChange(e) {
    var t = e.target;
    if (!t) return;
    if (
      t.matches &&
      (t.matches('input[data-pkg-addon]') ||
        t.matches('input[data-pkg-base]'))
    ) {
      var root = t.closest('[data-package-builder]');
      if (root) recalc(root);
    }
  }

  function handleClick(e) {
    var tabBtn = e.target.closest('[data-pkg-tab]');
    if (tabBtn) {
      var root = tabBtn.closest('[data-package-builder]');
      if (root) {
        e.preventDefault();
        setActiveTab(root, tabBtn.getAttribute('data-pkg-tab') || 'website');
      }
      return;
    }

    var submitBtn = e.target.closest('[data-pkg-submit]');
    if (submitBtn) {
      var root = submitBtn.closest('[data-package-builder]');
      if (!root) return;
      e.preventDefault();
      recalc(root);
      try {
        sessionStorage.setItem('ym_package_request', root.dataset.pkgPayload || '{}');
      } catch (err) {
        /* ignore */
      }
      window.location.href = root.getAttribute('data-contact-url') || '/pages/contact';
    }
  }

  function boot() {
    document.querySelectorAll('[data-package-builder]').forEach(function (root) {
      var tab = getActiveTab(root);
      root.setAttribute('data-active-tab', tab);
      updateTabs(root, tab);
      setPanelVisibility(root, tab);
      setAddonVisibility(root, tab);
      recalc(root);
    });
  }

  document.addEventListener('change', handleChange);
  document.addEventListener('click', handleClick);

  document.addEventListener('shopify:section:load', function (ev) {
    var root = ev.target && ev.target.querySelector && ev.target.querySelector('[data-package-builder]');
    if (root) {
      var tab = getActiveTab(root);
      root.setAttribute('data-active-tab', tab);
      updateTabs(root, tab);
      setPanelVisibility(root, tab);
      setAddonVisibility(root, tab);
      recalc(root);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 0);
})();
